import React from 'react'
import { Route } from 'react-router-dom'
import FullPage from './Fullpage'
//import Default from './Default'

const DefaultRoutes = ({ component: Component, ...rest }) => {

    return (
        <Route  {...rest} render={props => (
            <FullPage>
                <Component {...props} />
            </FullPage>
        )} />
    )
}

export default DefaultRoutes